import { getTimeObject } from "../constant/helper";

const TimeShower = ({ time }) => {
  if (!time || time === 0) {
    return `00:00`;
  }

  const { days, hours, minutes, seconds } = getTimeObject(time);

  function getParsedNum(num, type = "other") {
    if (!num || num === 0 || num === "0") {
      if (type === "minutes") {
        return "00:";
      } else if (type === "seconds") {
        return "00";
      }
    }

    if (!num || num === 0) {
      return "";
    }

    if (num >= 10) {
      if (type === "days") {
        return `${num}،`;
      }
      if (type === "seconds") {
        return `${num}`;
      }

      return `${num}:`;
    } else {
      if (type === "days") {
        return `${num} روز :`;
      }
      if (type === "seconds") {
        return `0${num}`;
      }
      return `0${num}:`;
    }
  }

  return `${getParsedNum(days, "days")}${getParsedNum(hours)}${getParsedNum(
    minutes,
    "minutes"
  )}${getParsedNum(seconds, "seconds")}`;
};

export default TimeShower;
